export default __webpack_public_path__ + "static/media/School-min.3176647b.png";